import { Component, Host, h, JSX, Prop } from '@stencil/core'

@Component({
    tag: 'zr-rating-stars',
    styleUrl: 'zr-rating-stars.scss',
    shadow: true,
})

/**
 * ZooRoyal ratings component.
 */
export class ZrRatingStars {
    /**
     * The average product-rating.
     */
    @Prop() value: string|number

    /**
     * Build Star Array JSX for render.
     */
    private getStars = () => {
        const floatNumber = (typeof this.value === 'string') ? parseFloat(this.value.replace(',','.')) : this.value
        return [1,2,3,4,5].map((i:number) => (
            <span class={{
                'zr-rating-stars__icon-star--filled': i <= floatNumber,
                'zr-rating-stars__icon-star--half-filled': floatNumber < i &&
                    floatNumber > i - 1 &&
                    floatNumber % 1 >= 0.5,
                'zr-rating-stars__icon-star': floatNumber < i &&
                    !(floatNumber > i &&
                        floatNumber % 1 >= 0.5) }}>
            </span>
        ))
    }

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {

        return (
            <Host>
                {this.getStars()}
            </Host>
        )
    }
}

